var $52b96f86422025af$exports = {};
$52b96f86422025af$exports = {
    "dismiss": `\u{BB34}\u{C2DC}`
};


export {$52b96f86422025af$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
